module.exports = __webpack_public_path__ + "img/erp-support.02f72a12.png";